export default {
    en: {
        req: 'required',
        amount_send: 'Amount and currency',
        amount: 'Amount',
        sender_name: 'Sender (you)',
        name_send: `Beneficiary's full name`,
        name_placeholder: `John Wick`,
        phone_send: `Beneficiary's phone number`,
        card_send: `Beneficiary's card number`,
        account_send: `Beneficiary's account number`,
        telegram: 'Telegram nickname',
        telegram_placeholder: '@nickname',
        payment_method: `Choose payment system`,
        bank_list: `Choose bank`,
        pay_sys_comission: 'Payment system commission',
        bank_comission: 'Bank commission',
        service_comission: 'Сommission of service',
        guaranteed_rate: 'Guaranteed rate',
        exchange_rate: 'Exchange rate',
        guaranteed_rate_total: 'Total guaranteed rate',
        guaranteed_time: '15 minutes',
        time_title: 'Approximate translation time',
        limits_title: 'Limits for transfer',
        limits_text: 'This rate is not related to the central bank and is calculated based on exchange data.',
        amount_receive: 'Amount and currency to receive',
        select_currency: 'Select currency',
        translation_time: 'Translation time: 15 minutes',
        recipient_list: 'Recipient list',
        choose_recipient: 'Choose recipient',
        create_recipient: 'Create a new recipient',
        select_recipient: 'Choose recipient',
        show_description: 'Show description',
        hide_description: 'Hide description',
        button: 'Create a transfer',
        button_bill: 'Pay the bill',
        before: 'Pre-registration required',
        first_transfer: 'You have a test transfer for a ',
        do_first_transfer: 'Make a first transfer',
        first_transfer_title: 'What is a test transfer?',
        first_transfer_text: 'For the first time, you can transfer only 500 rubles in order to make sure of the quality of our service. After a successful transfer, you will be able to transfer amounts according to the limits.',
        success_title: 'Success',
        success_subtitle: 'Transfer created successfully',
        sums_dont_add_up: 'The currency exchange rate has been updated. Try to refresh the page',
        no_such_merchants: 'There are no available merchants for the transfer. Try to choose another bank or text us in chat',
        network_list: 'Choose network',
        wallet_address_send: 'Recipient wallet address',
        more: 'More',
        profile: 'Profile',
        days: 'days',
        hours: 'hours',
        minutes: 'minutes',
        seconds: 'seconds',
        description: 'Description',
        description_text: 'Transfer description',
        type_card: 'Transfer to card',
        type_sbp: 'Transfer through the SBP',
        type_stock: 'Transfer through the exchange',
        type_wallet: 'Transfer to wallet',
        type_swift: 'Transfer via SWIFT',
        type_atm: 'Withdrawal through ATM',
        type_office: 'Withdrawal at the office',
        type_crypto: 'Cryptocurrency transfer',
        err_no_banks: 'Banks not loaded, try to refresh the page',
        err_no_bank: 'There is currently no way to send to this bank',
        err_payment_systems_loaded: 'Payment systems not loaded, try to refresh the page',
        err_payment_system: 'Payment system not found, try to refresh the page',
        err_no_currencies_loaded: 'Currencies not loaded, try to refresh the page',
        err_no_rates_loaded: 'Exchange rates not loaded, try to refresh the page',
        err_no_rate: 'Exchange rate not found, try to refresh the page',
        err_bill_dont_exist: 'This bill does not exist',
        critical_error: 'There are no available merchants for the transfer. Try to refresh the page or come back later. Or text us in chat.',
        no_rates_loaded: 'No exchange rates loaded. Try to refresh the page or text us in chat',
        no_rates_filtered: 'No exchange rates found. Try to reset the filter',
        err_no_currency_loaded: 'There are no available currencies for the exchange. Try to refresh the page or text us in chat',
        no_send_pay_sys: 'There are no available payment systems for the transfer. Try to choose another bank or text us in chat',
        error_title: 'Error',
        err_enough_deposit: 'There is currently no way to send to this bank',
    },
    ru: {
        req: 'обяз',
        amount_send: 'Сумма и валюта отправления',
        amount: 'Сумма',
        sender_name: 'Отправитель (вы)',
        name_send: `Имя и фамилия получателя`,
        name_placeholder: 'Ivan Petrov',
        phone_send: `Номер телефона получателя`,
        card_send: `Номер карты получателя`,
        account_send: `Номер счета получателя`,
        telegram: 'Телеграм ник',
        telegram_placeholder: "Ваш никнейм в телеграме",
        payment_method: `Выберите банк отправителя (ваш банк)`,
        bank_list: `Выберите банк получателя`,
        pay_sys_comission: 'Комиссия платежной системы',
        bank_comission: 'Комиссия банка',
        service_comission: 'Комиссия сервиса',
        guaranteed_rate: 'Обменный курс',
        exchange_rate: 'Биржевой курс',
        guaranteed_rate_total: 'Итоговый обменный курс',
        guaranteed_time: '15 минут',
        time_title: 'Примерное время перевода',
        limits_title: 'Лимиты за перевод',
        limits_text: 'Данный курс не связан с центральным банком и расчитывается на основе данных торговых бирж.',
        amount_receive: 'Сумма и валюта к получению',
        select_currency: 'Выберите валюту',
        translation_time: 'Время перевода: 15 минут',
        recipient_list: 'Список получателей',
        choose_recipient: 'Выберите получателя',
        create_recipient: 'Создать нового получателя',
        select_recipient: 'Выберите получателя',
        show_description: 'Добавить описание',
        hide_description: 'Скрыть описание',
        button: 'Создать перевод',
        button_bill: 'Оплатить счет',
        before: 'Предварительно необходимо пройти регистрацию',
        first_transfer: 'Вам доступен тестовый перевод на',
        do_first_transfer: 'Сделать тестовый перевод',
        first_transfer_title: 'Что такое тестовый перевод?',
        first_transfer_text: 'В первый раз вы можете перевести всего 500 рублей для того, чтобы убедиться в качестве нашего сервиса. После успешного перевода вы сможете переводить суммы согласно лимитам.',
        success_title: 'Успех',
        success_subtitle: 'Перевод успешно создан',
        sums_dont_add_up: 'Курс валюты обновился. Попробуйте обновить страницу',
        no_such_merchants: 'Нет доступных мерчантов для выполнения перевода. Попробуйте выбрать другой банк или напишите нам в чат',
        network_list: 'Выберите сеть',
        wallet_address_send: 'Адрес кошелька получателя',
        more: 'Подробности',
        profile: 'Профиль',
        days: 'дня',
        hours: 'часов',
        minutes: 'минут',
        seconds: 'секунд',
        description: 'Описание',
        description_text: 'Описание перевода',
        type_card: 'Перевод на карту',
        type_sbp: 'Перевод через СБП',
        type_stock: 'Перевод через биржу',
        type_wallet: 'Перевод на кошелек',
        type_swift: 'Перевод через SWIFT',
        type_atm: 'Выдача через банкомат',
        type_office: 'Выдача в офисе',
        type_crypto: 'Перевод криптовалюты',
        err_no_banks: 'Не загружены банки, попробуйте обновить страницу',
        err_no_bank: 'В данный момент нет возможности отправить на этот банк',
        err_payment_systems_loaded: 'Не загружены платежные системы, попробуйте обновить страницу',
        err_payment_system: 'Не найдена платежная система, попробуйте обновить страницу',
        err_no_rates_loaded: 'Не загружены курсы валют, попробуйте обновить страницу',
        err_no_currencies_loaded: 'Не загружены валюты, попробуйте обновить страницу',
        err_no_rate: 'Не найден курс валюты, попробуйте обновить страницу',
        err_bill_dont_exist: 'Такого счета не существует',
        critical_error: 'Нет доступных мерчантов для выполнения перевода. Попробуйте обновить страницу, или зайти позже, или напишите нам в чат.',
        no_rates_loaded: 'Не загружены курсы обмена. Попробуйте обновить страницу или напишите нам в чат',
        no_rates_filtered: 'Не найдены курсы обмена. Попробуйте сбросить фильтр',
        err_no_currency_loaded: 'В данный момент нет доступных валют для обмена. Попробуйте обновить страницу или напишите нам в чат',
        no_send_pay_sys: 'Нет доступных платежных систем для отправки перевода. Попробуйте выбрать другой банк или напишите нам в чат',
        error_title: 'Ошибка',
        err_enough_deposit: 'В данный момент нет возможности отправить на этот банк',
    }
}